export default __webpack_public_path__ + "static/PersonalBlog-f23e1fff152283f10f78f263ef07d6c6.png";